<h1 class="title">Space Grouping</h1>
<h5>Manage common spaces</h5>

<form class="cas-wrapper">
    <acabim-bim-visualiser-location-selector
            [cardTitle]="'Location & Building'"
            (locationEmitter)="setLocation($event)"
    ></acabim-bim-visualiser-location-selector>

    <acabim-card *ngIf="selectedSpace" [cardContent]="space"
                 [isCollapsible]="true" [isCollapsed]="false"
                 [hasHelpButton]="true"
                 [helpMessage]="'Add the selected space to a selection basket before adding to a new or existing group'"
                 cardHeading="Selected space details"></acabim-card>

    <acabim-card *ngIf="spaceGuids.length > 0" [cardContent]="spaceTable"
                 [isCollapsible]="true"
                 [isCollapsed]="false"
                 [hasHelpButton]="true"
                 [helpMessage]="'Add spaces to or remove spaces from a group'"
                 cardHeading="Manage spaces in group"></acabim-card>

    <acabim-card *ngIf="spaceGuids.length > 0" [cardContent]="manageGroups"
                 [isCollapsible]="true" [isCollapsed]="true"
                 [helpMessage]="'Create a new group or delete an existing group'"
                 [hasHelpButton]="true"
                 cardHeading="Manage groups"></acabim-card>

</form>


<ng-template #space>
    <div class="cas-pad" *ngIf="selectedSpace">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-12">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Space number</acabim-form-input-label>
                <acabim-form-input-content>
                    {{selectedSpace ? selectedSpace.spaceNumber : ''}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Space name</acabim-form-input-label>
                <acabim-form-input-content>
                    {{selectedSpace ? selectedSpace.name : ''}} ({{selectedSpace ? selectedSpace.longName : ''}})
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Description</acabim-form-input-label>
                <acabim-form-input-content>
                    {{selectedSpace ? selectedSpace.description : ''}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Function</acabim-form-input-label>
                <acabim-form-input-content>
                    {{selectedSpace ? selectedSpace.function : ''}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Floor area</acabim-form-input-label>
                <acabim-form-input-content>
                        {{selectedSpace ? (selectedSpace.floorArea/1000000 | number) : ''}}
                        <span class="cas-form-units">m²</span>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Perimeter length</acabim-form-input-label>
                <acabim-form-input-content>
                    {{selectedSpace ? (selectedSpace.netPerimeter/1000 | number) : ''}}
                    <span class="cas-form-units">m</span>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Elevation</acabim-form-input-label>
                <acabim-form-input-content>
                        {{selectedSpace ? (selectedSpace.elevation/1000 | number) : ''}}
                        <span class="cas-form-units">m</span>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <div class="cas-action-buttons">
            <button (click)="showViewerAction()">View plan</button>
            <button class="cas-button-action" (click)="addSpaceFromDropdown(selectedSpace.guid)">Add to selection</button>
        </div>
    </div>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<acabim-modal [title]="'2D BIM Viewer'" [display]="showViewer" (status)="setViewerStatus($event)" height="90vh">
    <acabim-bim-visualiser-twod-viewer *ngIf="showViewer"
                                       [projectId]="selectedProject ? (selectedProject.id ? selectedProject.id : '') : '' "
                                       [multiSelect]="false"
                                       (currentSelection)="getSelectedSpaces($event)"
                                       style="height: 90vh !important;"></acabim-bim-visualiser-twod-viewer>
    <p-footer>
        <div class="cas-action-buttons">
            <button class="cas-button-action" (click)="addSpaceFromDropdown(viewerSelectedSpace)">OK</button>
        </div>
    </p-footer>
</acabim-modal>

<!--<acabim-modal [title]="'Manage Groups'" [display]="showAction" (status)="modalStatus($event)" height="60vh" width="60vw">-->
    <ng-template #manageGroups>
        <div class="cas-pad">
            <acabim-datatable [dataSources]="modalDS" #modalTable></acabim-datatable>
            <h6 *ngIf="actionId === 1">Add To Group</h6>
            <h6 *ngIf="actionId === 2">Remove From Group</h6>
            <div class="cas-pad">
                <p-tabView orientation="right" (onChange)="selectTab($event)" [activeIndex]="index">
                    <p-tabPanel header="Existing Group">
                        <ng-template pTemplate="content">
                            <div *ngIf="!spaceDataLoading else loadingView" class="cas-wrapper">
                                <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-12">
                                    <acabim-form-input-wrapper>
                                        <acabim-form-input-label>Select group</acabim-form-input-label>
                                        <acabim-form-input-content>
                                            <p-dropdown
                                                    [options]="spaceGroupsInBuilding"
                                                    [(ngModel)]="selectedGroup"
                                                    optionLabel="name"
                                                    placeholder="Select Group"
                                            ></p-dropdown>
                                        </acabim-form-input-content>
                                    </acabim-form-input-wrapper>
                                </acabim-form-block>
                                <div class="cas-action-buttons">
                                    <button class="cas-button-action" (click)="deleteGroup()">Delete</button>
                                </div>
                            </div>
                            <div class="cas-wrapper" *ngIf="selectedGroup">
                                <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-12">
                                    <acabim-form-input-wrapper>
                                        <acabim-form-input-label>Description</acabim-form-input-label>
                                        <acabim-form-input-content>
                                            {{selectedGroup.description}}
                                        </acabim-form-input-content>
                                    </acabim-form-input-wrapper>
                                </acabim-form-block>
                                <div class="cas-action-buttons">
                                    <button class="cas-button-action" *ngIf="actionId === 1" (click)="addToExistingGroup()">OK
                                    </button>
                                    <button class="cas-button-action" *ngIf="actionId === 2"
                                            (click)="removeFromExistingGroup()">OK
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </p-tabPanel>
                    <p-tabPanel header="New Group">
                        <ng-template pTemplate="content">
                            <div *ngIf="!spaceDataLoading else loadingView">
                                <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-6">
                                    <acabim-form-input-wrapper>
                                        <acabim-form-input-label>Name</acabim-form-input-label>
                                        <acabim-form-input-content>
                                            <input [(ngModel)]="newGroupName">
                                        </acabim-form-input-content>
                                    </acabim-form-input-wrapper>
                                    <acabim-form-input-wrapper>
                                        <acabim-form-input-label>Description</acabim-form-input-label>
                                        <acabim-form-input-content>
                                            <input [(ngModel)]="newGroupDescription">
                                        </acabim-form-input-content>
                                    </acabim-form-input-wrapper>
                                </acabim-form-block>
                                <div class="cas-action-buttons">
                                    <button class="cas-button-action" (click)="addToNewGroup()">OK</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-tabPanel>
                </p-tabView>
            </div>
        </div>
    </ng-template>
<!--    <p-toast position="center" key="modal"></p-toast>-->
<!--    <div class="mb-2" *ngIf="showAction">-->
<!--        -->
<!--    </div>-->
<!--</acabim-modal>-->

<ng-template #spaceTable>
    <div class="cas-pad">
        <acabim-datatable [dataSources]="dataSources" #dataTable></acabim-datatable>
    </div>
</ng-template>

<p-toast position="center"></p-toast>
